import { NextSeo } from 'next-seo';
import React from 'react';
import PageHeader from '../components/PageHeader';
import TheBannersPage from '../components/TheBannersPage';
import config from '../config';

function BannersPage() {
  const title = `Banner Builder - ${config.siteName}`;
  const description = `Create 𝕏 banners to show off your Shitty Kitties.`;

  return (
    <>
      <NextSeo title={title} description={description} />
      <div className='pb-12 md:pb-48 bg-bg'>
        <PageHeader
          heading={'Banner Builder'}
          description={description}
          docsLink='https://docs.shittykitties.art/website-utilities/shitty-banner-builder'
        />
        <div className='px-4 max-w-7xl lg:mx-auto lg:px-8'>
          <TheBannersPage />
        </div>
      </div>
    </>
  );
}

export default BannersPage;
